<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="single-line jiudianjiagejiegou">
        <div class="chart-title">酒店价格结构（平日价格）</div>
        <div class="chart-content">
          <RoseCircle
            id="jiudianjiagejiegou"
            :chartData="JiudianJiageJiegouFenxiData"
            v-if="JiudianJiageJiegouFenxiData.length"
          />
        </div>
      </div>
      <div class="single-line gediqujiudianziyuanduibi">
        <div class="chart-title">各地区酒店资源对比</div>
        <div class="chart-content">
          <StackBar2
            id="gediqujiudianziyuanduibi"
            :chartData="GediquJiudianZiyuanDuibiData"
            xy="y"
            :barWidth="25"
          />
        </div>
      </div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import RoseCircle from "@/components/Echarts/RoseCircle.vue";
import StackBar2 from "@/components/Echarts/StackBar2.vue";

export default {
  name: "JiudianZiyuanFenxiDetail",
  components: {
    ChildModal,
    RoseCircle,
    StackBar2
  },
  props: {},
  data() {
    return {
      JiudianJiageJiegouFenxiData: [],
      GediquJiudianZiyuanDuibiData: null
    };
  },
  mounted() {
    // 请求酒店价格结构分析
    fetch(
      "/data/ZiyuanPinggu/JiudianZiyuanFenxiDetail/JiudianJiageJiegouFenxi.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JiudianJiageJiegouFenxiData = json.data;
      });
    // 请求各地区酒店资源对比
    fetch(
      "/data/ZiyuanPinggu/JiudianZiyuanFenxiDetail/GediquJiudianZiyuanDuibi.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.GediquJiudianZiyuanDuibiData = json.data;
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
.jiudianjiagejiegou .chart-content {
  width: 80%;
  height: 210px;
  transform: translateX(-0.7rem);
}
.gediqujiudianziyuanduibi .chart-content {
  height: 240px;
  transform: translateX(0.2rem);
}
</style>
